// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__eDK99","calendarButtons":"ClockData_calendarButtons__1Eu_u"};